import React, { memo } from 'react';

import { Box, Button, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { AiChatTestIds } from '../../../../../AiChat.testIds';

import {
  confirmActionsButtonStyles,
  confirmActionsContainerStyles,
} from './ConfirmActionsContent.styles';

const ConfirmActionsContent = ({ contentProps }) => (
  <Box sx={confirmActionsContainerStyles}>
    <Button
      data-testid={AiChatTestIds.CONFIRM_ACTIONS_CONTENT_SUBMIT_BUTTON}
      sx={confirmActionsButtonStyles}
      onClick={contentProps.onSubmit}
    >
      <Typography variant="regular14">{contentProps.submitLabel}</Typography>
    </Button>
    <Button
      data-testid={AiChatTestIds.CONFIRM_ACTIONS_CONTENT_CANCEL_BUTTON}
      sx={confirmActionsButtonStyles}
      variant="outlined"
      onClick={contentProps.onCancel}
    >
      <Typography variant="regular14">{contentProps.cancelLabel}</Typography>
    </Button>
  </Box>
);

ConfirmActionsContent.propTypes = {
  contentProps: PropTypes.shape({
    submitLabel: PropTypes.string.isRequired,
    cancelLabel: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
  }).isRequired,
};

export default memo(ConfirmActionsContent);
